<template>
	<div class="grid-flex-container pa-4">
		<v-container
			fluid
			class="flexContainerItem mb-2"
			style="overflow: hidden"
		>
			<v-form ref="nameForm" class="d-flex">
				<v-row no-gutters>
					<v-col cols="6">
						<v-text-field
							class="py-0 mr-2"
							label="Workbook Name"
							v-model="wrName"
							single-line
							:rules="[rules.ruleRequired]"
						/>
					</v-col>
					<v-col cols="2" class="d-flex align-center justify-center">
						<v-switch
							v-model="wrIsSingleFilter"
							label="Single-filter"
							v-if="isSingleFilter"
						/>
					</v-col>
					<v-col cols="2" class="d-flex align-center justify-center">
						<v-switch
							v-model="wrIsVisible"
							label="Visible for all users"
						/>
					</v-col>
					<v-col cols="2" class="d-flex align-center justify-end">
						<v-btn
							color="primary"
							@click="addNewReport()"
							v-if="reports && reports.length > 0"
						>
							<v-icon class="mr-1"> mdi-plus</v-icon>Add new
							report
						</v-btn>
					</v-col>
				</v-row>
			</v-form>
		</v-container>
		<div class="generic-grid-container mt-2">
			<v-form ref="form" class="grid-flex-container">
				<v-list v-if="workbookReports && workbookReports.length > 0">
					<draggable
						v-model="workbookReports"
						@change="reorder"
						handle=".draggable-handle"
					>
						<v-list-item
							v-for="(item, index) in workbookReports"
							:key="index"
							:value="item"
						>
							<v-list-item-content class="py-1">
								<workbook-item
									:item="item"
									@removeReport="deleteReport(item)"
								/>
							</v-list-item-content>
						</v-list-item>
					</draggable>
				</v-list>
			</v-form>
		</div>

		<v-container fluid class="mt-2">
			<v-row no-gutters>
				<v-spacer />
				<v-btn text outlined class="mr-2" @click.stop="onCancel()"
					>Cancel</v-btn
				>
				<v-btn color="primary" @click.stop="onSave()">
					<v-icon class="mr-1">mdi-content-save</v-icon>Save
				</v-btn>
			</v-row>
		</v-container>
	</div>
</template>
<script>
import Draggable from 'vuedraggable';
import WorkbookItem from './WorkbookItem.vue';
import { mapGetters } from 'vuex';
import { WorkbookDetailsGetters } from '../../../../store/getters';
import { WorkbookDetailsActions } from '../../../../store/actions';
import fieldsValidationRules from '../../../../utils/fieldsValidationRules';
export default {
	name: 'WorkbookDetails',
	computed: {
		...mapGetters({
			reports: [WorkbookDetailsGetters.REPORTS],
			workbook: [WorkbookDetailsGetters.WORKBOOK],
		}),

		isSingleFilter() {
			if (
				this.workbookReports &&
				this.workbookReports.length >= 1 &&
				!this.workbookReports.some(
					(item) =>
						item.Report != null &&
						item.Report.GridViewId === null &&
						item.Report.CustomData !== null
				) &&
				(() => {
					const entityIds = this.workbookReports
						.filter(
							(item) =>
								item.Report != null &&
								item.Report.GridView !== null
						)
						.map((item) => item.Report.GridView.Entity.Id);
					return (
						entityIds.length > 1 &&
						entityIds.every((id) => id === entityIds[0])
					);
				})()
			) {
				return true;
			} else {
				return false;
			}
		},
		rules() {
			return fieldsValidationRules;
		},
	},
	components: { Draggable, WorkbookItem },
	data() {
		return {
			workbookReports: [],
			wrName: '',
			wrIsVisible: false,
			wrIsSingleFilter: false,
			isRequired: (value) => !!value || 'Value is required',
			headers: [
				{
					text: 'Report Name',
					value: 'Name',
				},
				{
					text: 'Tab Name',
					value: 'TabName',
				},
				{
					sortable: false,
					width: '0px',
					text: '',
					value: 'actions',
				},
			],
		};
	},

	mounted() {
		if (this.$route.params.workbookId) {
			this.$store
				.dispatch(
					WorkbookDetailsActions.LOAD_DATA,
					this.$route.params.workbookId
				)
				.then(() => {
					if (this.workbook) {
						this.wrName = this.workbook.Name;
						this.wrIsVisible = this.workbook.IsVisible;
						this.wrIsSingleFilter = this.workbook.IsSingleFilter;
						if (
							this.workbook.WorkbookReports &&
							this.workbook.WorkbookReports.length > 0
						) {
							let wr = JSON.parse(
								JSON.stringify(this.workbook.WorkbookReports)
							).sort((a, b) => (a.Order > b.Order ? 1 : -1));
							this.workbookReports = wr;
						}
					}
				});
		}
	},

	destroyed() {
		this.$store.dispatch(WorkbookDetailsActions.CLEAR);
	},
	methods: {
		reorder() {
			this.workbookReports.forEach((wr, index) => {
				wr.Order = index + 1;
			});
		},
		deleteReport(item) {
			let index = this.workbookReports.indexOf(item);
			if (index >= 0) {
				this.workbookReports.splice(index, 1);
			}
		},
		addNewReport() {
			let item = {
				ReportId: null,
				TabName: '',
				Order: this.workbookReports.length + 1,
			};
			this.workbookReports.push(item);
		},
		onCancel() {
			this.$router.go(-1);
		},
		onSave() {
			let wb = {};
			if (this.workbook) {
				wb = JSON.parse(JSON.stringify(this.workbook));
			}

			wb.Name = this.wrName;
			wb.IsVisible = this.wrIsVisible;
			wb.IsSingleFilter = this.wrIsSingleFilter;
			wb.WorkbookReports = this.workbookReports;

			if (!this.isSingleFilter) {
				wb.IsSingleFilter = false;
			}

			this.$nextTick(() => {
				if (
					this.$refs.form.validate() &&
					this.$refs.nameForm.validate()
				) {
					this.$store
						.dispatch(WorkbookDetailsActions.SAVE, wb)
						.then(() => {
							this.onCancel();
						});
				}
			});
		},
	},
};
</script>
